// extracted by mini-css-extract-plugin
export default {"informationBanner":"style_informationBanner__vcLdl","icon":"style_icon__iXjT5","title":"style_title__lqq2B","body":"style_body__X8Ubs","submit":"style_submit__ZyBE+"};